import {
    URLAPI,
    PRODUCT_TYPE_PATH,
    PRODUCT_TYPE_CREATE_PATH,
    PRODUCT_TYPE_UPDATE_PATH,
} from "../config/index";
import {LOGOUT} from './users';
import axios from "axios";

const init = {
    _get_all_product_type: {
        data: [],

        status: 0,
        message: {},
    },

    _create_product_type: {
        data: {},
        status: 0,
        message: {},
    },
    _update_product_type: {
        data: {},
        status: 0,
        message: {},
    },
};

const GET_ALL_PRODUCT_TYPE = "GET_ALL_PRODUCT_TYPE";
export const CREATE_PRODUCT_TYPE = "CREATE_PRODUCT_TYPE";
export const UPDATE_PRODUCT_TYPE = "UPDATE_PRODUCT_TYPE";

export const product_type_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_PRODUCT_TYPE:
            return {
                ...state,
                _get_all_product_type: action.payload,
            };
        case CREATE_PRODUCT_TYPE:
            return {
                ...state,
                _create_product_type: action.payload,
            };
        case UPDATE_PRODUCT_TYPE:
            return {
                ...state,
                _update_product_type: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const getAllProductType = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${PRODUCT_TYPE_PATH}`, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_PRODUCT_TYPE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: GET_ALL_PRODUCT_TYPE,
                payload: {
                    data: [],
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_PRODUCT_TYPE,
                payload: {
                    data: [],
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const createProductType = (token, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.post(
            `${URLAPI}${PRODUCT_TYPE_CREATE_PATH}`,
            form,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_PRODUCT_TYPE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_PRODUCT_TYPE,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_PRODUCT_TYPE,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updateProductType = (token, id, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.patch(
            `${URLAPI}${PRODUCT_TYPE_UPDATE_PATH}${id}/`,
            form,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_PRODUCT_TYPE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: UPDATE_PRODUCT_TYPE,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_PRODUCT_TYPE,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const clear_product_type = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
